import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from '../UI/Modal';
import {classNamesPrefixed} from "../../../helpers/CoreHelpers";
import BtnPrimary from "../UI/BtnPrimary";
import SelectField from "../Fields/SelectField";

class GlobalFieldSelectModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            insert: null
        };

        this.onClose = this.onClose.bind(this);
        this.onInsert = this.onInsert.bind(this);
        this.selectVariable = this.selectVariable.bind(this);
    }

    onInsert(event) {
        if (this.props.onInsert && (typeof (this.props.onInsert) === "function")) {
            this.props.onInsert(this.props.name, this.state.insert);
        }

        this.onClose(event);
    }

    onClose(event) {
        this.setState({
            insert: null
        });

        if (typeof (this.props.onClose) === "function") {
            this.props.onClose();
        }

        if (event) {
            event.preventDefault();
        }
    }

    selectVariable(value) {
        this.setState({
            insert: value
        });
    }

    render() {
        const {show} = this.props;
        const {insert} = this.state;

        let globals = [];

        if (this.props.globals) {
            globals = this.props.globals.map((item) => {
                return {
                    id: item.key,
                    title: item.key
                }
            });
        }

        return (
            <div className={classNamesPrefixed({'global-variables-select-modal': true})}>
                <Modal
                    noScroll={true}
                    showModal={show}
                    className={'global-variable-select'}
                    title={"Insert global variable"}
                    icon={"plus"}
                    onClose={() => this.onClose()}
                    modalFooter={
                        <div className={classNamesPrefixed({'form-actions': true, 'media-select-form-actions': true})}>
                            <BtnPrimary small disabled={!insert} onClick={(event) => this.onInsert(event)}>
                                {"Insert variable"}
                            </BtnPrimary>
                        </div>
                    }
                >
                    <div className={classNamesPrefixed({'global-variables-select-modal': true,})}>
                        <SelectField
                            placeholder={"Select the variable"}
                            clearable={true}
                            items={globals}
                            omitCollapsible={true}
                            afterOnChangeObject={this.selectVariable}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        globals: state.global.items
    };
};

export default connect(mapStateToProps)(GlobalFieldSelectModal)


// WEBPACK FOOTER //
// ./src/core/admin/components/Forms/GlobalFieldSelectModal.js